import { schoolCode, schoolName } from "../../util/Constants";
import CustomButton from "../../components/CustomButton";
import QueryForm from "../../components/QueryForm";
import { FormRenderConfig } from "../../components/FromFieldRenderer";
import { useQueryForm } from "../../util/hooks/useQueryForm";
import QueryApis from "../../api/QueryApis";
import { toast } from "sonner";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getSchoolBranchByCode } from "../../features/school-branch-controller/schoolBranchSlice";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useSelector } from "react-redux";

export default function QueriesLink() {
  const { id } = useParams<{ id: string }>();
  const queryId = Number(id);
  const [loading, setLoading] = useState(true);
  const { branchCode } = useParams();

  const dispatch = useDispatch<AppDispatch>();
  const { branchDetails } = useSelector(
    (state: RootState) => state.schoolBranch,
  );

  useEffect(() => {
    dispatch(getSchoolBranchByCode());
  }, [dispatch, branchCode]);

  const {
    formFields,
    formData,
    setFormData,
    handleChange,
    isFormValid,
    resetForm,
  } = useQueryForm(branchCode);

  useEffect(() => {
    if (!queryId) return;

    QueryApis.getQueryById(queryId)
      .then((res) => {
        setFormData(res.data);
      })
      .finally(() => setLoading(false));
  }, [queryId, setFormData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
       const payload = { ...formData, branchCode };
      if (queryId) {
        // If reshare update
        await QueryApis.updateQuery(queryId, payload);
      } else {
        await QueryApis.createQuery(payload);
        resetForm();
      }
    } catch (err) {
      toast.error("Failed to submit query");
    }
  };

  const config: FormRenderConfig = {
    dropdownAsRadio: true,
    imageVariant: "full",
  };

  return (
    <main className="min-h-screen bg-background-100 p-6">
      <section className="max-w-3xl mx-auto flex flex-col gap-6">
        <header className="flex flex-col items-center gap-2">
          <img
            src={branchDetails?.schoolBranchIcon}
            alt="logo"
            className="h-16"
          />
          <h3 className="text-2xl font-semibold">
            {branchDetails?.schoolBranchName}
          </h3>
          <p className="text-sm text-neutral-300">
            Please enter the details below
          </p>
        </header>

        <form
          className="grid gap-6 bg-white rounded-xl shadow-xl p-4 lg:p-6 lg:px-8"
          onSubmit={handleSubmit}
        >
          <h3 className="text-neutral-400 font-semibold text-md">
            Enquiry Questions
          </h3>
          <QueryForm
            fields={formFields}
            formData={formData}
            onChange={handleChange}
            setFormData={setFormData}
            config={config}
          />
          <span className="flex justify-end items-end text-error-500 font-medium text-xs">
            *By submitting, you agree to receive communication messages through
            Email/Whatsapp/SMS
          </span>
          <div className="flex justify-end items-end">
            <CustomButton
              type="submit"
              text="Submit Query"
              color="bg-primary-500"
              disabled={!isFormValid}
            />
          </div>
        </form>
      </section>
    </main>
  );
}
